export default "__VITE_ASSET__85bbc81a__"